<script>
import AuthLayout from './Auth/Auth.layout.vue';
import MainLayout from './Main/Main.layout.vue';

export default {
  name: 'Layouts',
  components: {
    AuthLayout,
    MainLayout,
  },
  computed: {
    name() {
      return `${this.$route.meta?.template || 'Main'}Layout`;
    },
  },
};
</script>
<template>
  <component :is="name"></component>
</template>
